// src/pages/HomePage.js
import jumboImage from '../../assets/images/jumbo-right-image.svg';
import happy from '../../assets/images/Happy.png';
import React from 'react';
import NavBar from '../../components/NavBar/NavBar';
import './Email.css';

// Images

// import OurServiceImage from './images/sms-messages-icon.png'
import ourServiceImage from '../../assets/images/sms-messages-icon.png'
import ourServicePasscode from '../../assets/images/passcode-icon.png'
import ourServiceEmail from '../../assets/images/email-address-icon.png'
// import integrateImage from './images/Mask-group.png'
// import integrateImage from '../../assets/images/Mask-group.png'


const Email = () => {


    return (
        <div>
            
         
Email













        </div>
    );
}

export default Email;
